function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getValueByIdentifier as getValue, getSchemasArray } from '../tags/values/get-by-identifier';
import { EXTERNAL_IDENTIFIERS, IDENTIFIERS } from '../types/Identifiers';
import { TAG_TYPES } from '../types/TagTypes';
import { renderToStaticMarkup } from './render-to-static-markup';
import { updateValueByIdentifier } from './setters';
import { identify } from './utils/identify';
import { clone } from './utils/clone';

function getValueByIdentifier(_temp, identifier) {
  var _ref = _temp === void 0 ? {} : _temp,
      tags = _ref.tags;

  return getValue(tags, identifier);
}

function addMetaTag(data, props) {
  var identifier = identify({
    type: TAG_TYPES.META,
    props: props
  });

  if (identifier) {
    return updateValueByIdentifier(data, identifier, props.content);
  }

  var result = clone(data);
  result.tags.push({
    type: TAG_TYPES.META,
    props: props
  });
  return result;
}

function getTitle(data) {
  return getValueByIdentifier(data, EXTERNAL_IDENTIFIERS.TITLE);
}

function getDescription(data) {
  return getValueByIdentifier(data, EXTERNAL_IDENTIFIERS.DESCRIPTION);
}

function getCanonical(data) {
  return getValueByIdentifier(data, IDENTIFIERS.CANONICAL);
}

function getMetaTags(data, filter) {
  var tags = (data || {}).tags;

  if (Array.isArray(tags)) {
    return tags.reduce(function (acc, curr) {
      if (curr && curr.type === TAG_TYPES.META && curr.props) {
        if (filter) {
          var matches = Object.keys(filter).every(function (key) {
            return curr.props[key] === filter[key];
          });

          if (!matches) {
            return acc;
          }
        }

        return acc.concat(curr.props);
      }

      return acc;
    }, []);
  }

  return [];
}

function getSchemas(_temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
      tags = _ref2.tags;

  return getSchemasArray(tags);
}

function getLinks(data) {
  if (data === void 0) {
    data = {};
  }

  var tags = data.tags || [];
  return tags.filter(function (tag) {
    return tag.type === TAG_TYPES.LINK && tag.props && tag.props.rel !== IDENTIFIERS.CANONICAL.toLowerCase();
  }).map(function (tag) {
    return _objectSpread({}, tag.props);
  });
}

function getStaticMarkup(tags) {
  return renderToStaticMarkup(tags).join('\n');
}

export { addMetaTag, getCanonical, getDescription, getLinks, getMetaTags, getSchemas, getStaticMarkup, getTitle, getValueByIdentifier };